<template>
    <div class="margin-top-20">
        <div class="manage-title margin-bottom-20"><em class="txt">达人接单情况（{{count}}/{{split_num}}）</em></div>
        <div class="receipt">
            <el-row :gutter="20">
                <el-col :span="6" v-for="item in list" :key="item.id">
                    <div class="item flex align-items">
                        <div class="pic"><img :src="item.head_img"></div>
                        <div class="text flex flex-wrap align-items">
                            <p class="name">{{item.name}}（{{item.click_num}}/{{item.task_click}}）</p>
                            <p class="number">
                                <el-progress :percentage="Math.round(item.click_num/item.task_click*10000)/100.00"></el-progress>
                            </p>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ExtensionReceipt',
        props: {
            split_num: String,
            list: Array,
            count: String
        },
        methods: {
            format(percentage) {
                return percentage === 100 ? '满' : `${percentage}%`;
            }
        }
    }
</script>
<style scoped></style>
